import { createSlice } from "@reduxjs/toolkit";

const overlaysSlice = createSlice({
  name: "overlays",
  initialState: {
    data: [],
    show: false,
  },
  reducers: {
    setOverlays: (state, action) => {
      state.data = action.payload;
    },
    saveOverlay: (state, action) => {
      const payloadId = action.payload.id || action.payload._id;
      const existingIndex = state.data.findIndex((overlay) => (overlay.id || overlay._id) === payloadId);
      if (existingIndex !== -1) {
        state.data[existingIndex] = action.payload;
      } else {
        state.data.push(action.payload);
      }
    },
    deleteOverlay: (state, action) => {
      state.data = state.data.filter((overlay) => overlay.id !== action.payload);
    },
    clearOverlays: (state) => {
      state.data = [];
    },
    showOverlay: (state) => {
      state.show = true;
    },
    hideOverlay: (state) => {
      state.show = false;
    },
  },
});

export const { setOverlays, saveOverlay, deleteOverlay, clearOverlays, showOverlay, hideOverlay } =
  overlaysSlice.actions;
export const overlays = overlaysSlice.reducer;
export default overlaysSlice.reducer;
